function sanitizeExcelRows(rows) {
    // Étape 1 : Supprimer les lignes entièrement vides
    const filteredRows = rows.filter((row) =>
        row.some((cell) => cell !== null && cell !== undefined && cell !== "")
    );

    if (filteredRows.length === 0) return [];

  

   

    // Nettoyer et filtrer les colonnes vides
    return filteredRows.map((row) =>
        row
            .map((cell) => {
                if (typeof cell === "string") {
                    return cell
                        .trim()
                        .replace(/<script.*?>.*?<\/script>/gi, "")
                        .replace(/on\w+=".*?"/gi, "")
                        .replace(/javascript:/gi, "")
                        .replace(/&/g, "&amp;")
                        .replace(/</g, "&lt;")
                        .replace(/>/g, "&gt;");
                }

                return cell;
            })
           
    );
}

export default sanitizeExcelRows;
